import React from "react";
import CardServicosCompacto from "./cardServicosCompacto";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function CardsAms({ cards = [] }) {
    const { openModal } = useModal();
    return (
        <div className="w-full py-24 bg-[#040116] bg-[url('/assets/servicos/banner-cards-ams.png')] bg-cover bg-top bg-no-repeat">
            <div className="text-white container mx-auto px-4 space-y-8">
                <h2 className="font-inter-light text-center text-4xl mb-8 px-40 leading-12 pb-8">
                    Parceria completa e estratégica entre <br />
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                        a nossa equipe e a sua
                    </span>
                    .
                </h2>
                <div className="flex flex-wrap justify-center gap-4 pb-8">
                    {cards.map((card, index) => (
                        <CardServicosCompacto
                            key={index}
                            title={card.title}
                            text={card.text}
                            icon={card.icon}
                            iconHover={card.iconHover || card.icon}
                            glowColor={card.glowColor || "#FC0021"}
                            width={card.width}
                            height={card.height}
                            iconBgColor="#11112E"
                        />
                    ))}
                </div>

                <div className="flex justify-center">
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB] rounded-full py-3 px-8 text-white font-medium hover:scale-105 transition-transform duration-300 cursor-pointer"
                    >
                        Faça parte do Programa
                    </button>
                </div>
            </div>
        </div>
    );
}
